export default {
    business: [],
    businesspertype: [],
    businesspertypetotals: [],
    pipelines: [],
    filter_bussines: {},
    filter_bussines_view: "",
    filter_bussines_reload: "0",
}